import FileSaver from "file-saver";
import { utils, writeFile, write, read } from "xlsx";

export function useExcelUtility() {
    const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    
    type XLSHeaderColumn = { label: string; key: string };
    const exportToExcelJson: (data :any, fileName: string) => void = (
        data: any,
        fileName: string
    ) => {
        const worksheet = utils.json_to_sheet(data);
        const workbook = utils.book_new();
        utils.book_append_sheet(workbook, worksheet, "Sheet1");
        const excelBuffer = write(workbook, {
            bookType: "xlsx",
            type: "array",
        });
        const blob = new Blob([excelBuffer], {
            type: "application/octet-stream",
        });
        FileSaver(blob, `${fileName}.xlsx`);
    };

    const make_cols : (refstr: any) => any = (
        refstr: any
    )=> {
        var o = [],
        C = utils.decode_range(refstr).e.c + 1;
        for (var i = 0; i < C; ++i) {
            o[i] = { name: utils.encode_col(i), key: i };
        }
        return o;
    };

    const excelRenderer: (file: any, callback: any) => void = (
    file: any, callback: any) => {
    //export function ExcelRenderer(file: any, callback: any) {
        return new Promise(function (resolve, reject) {
            var reader = new FileReader();
            var rABS = !!reader.readAsBinaryString;
            var rAAB = !!reader.readAsArrayBuffer;
            reader.onload = function (e: any) {
                try {
                    /* Parse data */
                    var bstr = e.target.result;
                    //var wb = read(bstr, { type: rABS ? "binary" : "array" });
                    var wb = read(bstr, { type: rAAB ? "binary" : "array" });
                    /* Get first worksheet */
                    var wsname = wb.SheetNames[0];
                    var ws = wb.Sheets[wsname];

                    /* Convert array of arrays */
                    var json = utils.sheet_to_json(ws, { header: 1 });
                    var cols = make_cols(ws["!ref"]);

                    var data = { rows: json, cols: cols };

                    resolve(data);
                    return callback(null, data);
                } catch (e) {
                    return callback("Error", null);
                }
            };
            if (file && rABS) reader.readAsBinaryString(file);

            else reader.readAsArrayBuffer(file);
        });
    }




    const exportToExcel = (
        headers: XLSHeaderColumn[],
        csvData: any[],
        fileName: string,
        sheetName: string,
        customWsCols?: any,
        sendBack?: boolean
    ) => {
        var headerTitles: any = {};
        headers.forEach((x) => {
            headerTitles[x.key] = x.label;
        });

        const ws = utils.json_to_sheet([headerTitles], {
            header: headers.map((x) => x.key),
            skipHeader: true,
            //origin: 0 //ok
        });

        var xwscols = [];
        if (customWsCols === undefined) {
            for (var h = 0; h < headers.length; h++) {
                var maxLength = headers[h].label.length;
                for (var i = 0; i < csvData.length; i++) {
                    if (maxLength < csvData[i][headers[h].key].length)
                        maxLength = csvData[i][headers[h].key].length;
                }
                xwscols.push({ wch: maxLength });
            }
        } else {
            xwscols = customWsCols;
        }

        ws["!cols"] = xwscols;
        utils.sheet_add_json(ws, csvData, {
            header: headers.map((x) => x.key),
            skipHeader: true,
            origin: 1, //ok
        });

        var sheets: any = {};
        sheets[sheetName] = ws;

        const wb = { Sheets: sheets, SheetNames: [sheetName] };
        const excelBuffer = write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        if (sendBack === undefined || sendBack === false) {
            FileSaver.saveAs(data, fileName + fileExtension);
        } else {
            return new Uint8Array(excelBuffer);
            /*
    var nBytes = excelBuffer.byteLength,
      ui8Data = new Uint8Array(nBytes);
    for (var nIdx = 0; nIdx < nBytes; nIdx++) {
      ui8Data[nIdx] = excelBuffer.charCodeAt(nIdx) & 0xff;
    }
    return ui8Data;
    */
        }
    };


     return { exportToExcelJson, excelRenderer, exportToExcel };
}


